<template>
    <div class="pcLogin">
        <div class="mask">
            <div class="pcloginDialog" v-if="pcloginDialog">
                <!-- 关闭按钮 -->
                <div class="icon_close" @click="handleClose"></div>
                <div class="mainBox">
                    <!-- tab切换 -->
                    <div class="tabBox">
                        <div
                            class="tabItem"
                            :class="{ activeItem: tabIndex === 0 }"
                            @click="changeTabIndex(0)"
                        >
                            密码登录
                        </div>
                        <div
                            class="tabItem"
                            :class="{ activeItem: tabIndex === 1 }"
                            @click="changeTabIndex(1)"
                        >
                            手机号登录
                        </div>
                    </div>
                    <!-- 内容区--密码登录 -->
                    <div class="infoBox infoBox1" v-if="tabIndex === 0">
                        <!-- 手机号 -->
                        <div class="inputBox tel">
                            <input
                                type="text"
                                id="input_tel"
                                @change="checkPhone"
                                @input="handleInput"
                                maxlength="20"
                                v-model="tel"
                                placeholder="手机号/邮箱"
                            />
                            <!-- 错误或警告 -->
                            <div class="error" v-if="phoneError">
                                {{ phoneErrorInfo }} <i></i>
                            </div>
                            <div class="warning"></div>
                        </div>
                        <!-- 密码 -->
                        <div class="inputBox pwd">
                            <input id="input_pwd" type="password" v-model="pwd" placeholder="请输入密码"/>
                        </div>
                        <!-- 图形验证码 -->
                        <div class="inputBox graph" v-if="addition > 3">
                            <input
                                type="text"
                                v-model="verify"
                                class="graphInput"
                                placeholder="请输入图形验证码"
                            />
                            <div class="graphImg" @click="getGraphImg">
                                <img :src="graphImg" alt=""/>
                            </div>
                        </div>
                        <div class="handle">
                            <div class="rememberBox" @click="changeRemember">
                                <i :class="{ icon_checked: isRemember }"></i>记住我7天
                            </div>
                            <div class="forget" @click="forgetPwd">忘记密码？</div>
                        </div>
                    </div>
                    <!-- 内容区--手机号登录 -->
                    <div class="infoBox infoBox2" v-if="tabIndex === 1">
                        <!-- 手机号 -->
                        <div class="inputBox tel">
                            <input
                                id="input_phone"
                                type="text"
                                @change="checkPhone"
                                @input="handleInput"
                                maxlength="11"
                                v-model="phone"
                                placeholder="请输入手机号"
                                autocomplete="off"
                            />
                            <!-- 错误或警告 -->
                            <div class="error" v-if="phoneError">
                                {{ phoneErrorInfo }} <i></i>
                            </div>
                            <div class="warning"></div>
                        </div>
                        <!-- 图形验证码 -->
                        <div class="inputBox imgCode">
                            <input type="number" :class="imgCodeFlag ? 'ca_red' : ''" v-model="imgCode"
                                   :placeholder="imgCodeMessage" :contextmenu="false">
                            <img v-if="verifyImg" :src="verifyImg" alt="" @click="changeVerifyImg"
                                 :title="verifyImgTitle">
                        </div>
                        <!-- 验证码 -->
                        <div class="inputBox pwd">
                            <input
                                type="text"
                                id="input_code"
                                @change="checkCode"
                                v-model="code"
                                placeholder="请输入验证码"
                                autocomplete="off"
                            />
                            <div class="sendCode" @click="getCode" v-if="!cutdownIsShow">
                                获取手机验证码
                            </div>
                            <div class="sendCode second" v-if="cutdownIsShow">
                                {{ sendtxt }}
                            </div>
                        </div>
                        <div class="handle">
                            <div class="forget" @click="forgetPwd">忘记密码？</div>
                        </div>
                    </div>

                    <!-- 登录按钮 -->
                    <div
                        class="loginBtn"
                        @click="gotoLogin"
                        :class="{ canLogin: canLogin }"
                    >
                        登录
                    </div>
                    <!-- 协议 -->
                    <div class="agreement">
                        <i :class="{ icon_checked: isAgree }" @click="changeAgree"></i
                        >我已阅读并接受
                        <span @click="gotoAgree(1)">《用户协议》</span> 及<span
                        @click="gotoAgree(2)"
                    >《隐私政策》</span
                    >
                    </div>
                    <!-- 第三方 -->
                    <div class="thirdLogin">
                        <div class="thirdList">
                            <div
                                class="thirdItem thirdqq"
                                id="qqLoginBtn"
                                @click="handleThirdLogin(4)"
                            ></div>
                            <div class="thirdItem thirdwx" @click="handleThirdLogin(3)"></div>
                            <!-- <div
                              class="thirdItem thirdsina"
                              @click="handleThirdLogin(5)"
                            ></div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import QC from 'qc'
import {generateLetters, getBrowserNameVersion, getIPs, ipToNumber, replaceCharAtIndex} from '@/config/getSysInfo.js'
import md5 from 'js-md5';
import {Toast} from 'vant'
import Qs from 'qs'
import {ADDRESS} from '@/api/address.js'

const CryptoJS = require('crypto-js');
export default {
    name: '',
    data() {
        return {
            dialogIsShow: true,
            tabIndex: 0,
            // 是否记住7天
            isRemember: true,
            // 是否可以登录
            canLogin: false,
            // 是否同意协议
            isAgree: true,
            // 第三方登录(没用到)
            thirdList: [
                {
                    icon: 'https://images.zhibo.tv/3x/icon_qq@3x.png',
                    icon_h: 'https://images.zhibo.tv/3x/icon_qq_h@3x.png',
                    name: 'qq'
                },
                {
                    icon: 'https://images.zhibo.tv/3x/icon_weixin@3x.png',
                    icon_h: 'https://images.zhibo.tv/3x/icon_weixin_h@3x.png',
                    name: 'wechat'
                },
                // {
                //   icon: 'https://images.zhibo.tv/3x/icon_weibo@3x.png',
                //   icon_h: 'https://images.zhibo.tv/3x/icon_weibo_h@3x.png',
                //   name: 'sina'
                // }
            ],
            // 手机号+密码登录
            tel: '',
            pwd: '',
            // 手机号+验证码登录
            phone: '',
            code: '',
            // 倒计时
            time: 60,
            btntxt: '',
            cutdownIsShow: false,
            // 发送验证码
            sendtxt: '',
            // 图形验证码
            graphImg: '',
            // 是否展示图形验证码
            addition: '',
            verify: '',
            pcloginDialog: true,
            phoneError: false,
            phoneErrorInfo: '',

            // 2023年06获取短信验证码优化
            imgCodeMessage: '请输入图形验证码',
            imgCodeFlag: false,
            imgCode: '',
            statistics: '',
            source: '31',

            verifyImg: '',

            reqId_Len_A: '',
            reqId: '',
            reqTime: '',
            ip: '',
            reqCode: '',
            verifyImgTitle: '点击切换'

        }
    },
    computed: {
        // 密码登录时登录按钮是否可点
        pwdCanLogin() {
            const {tel, pwd} = this
            return {tel, pwd}
        },
        // 验证码登录时登录按钮是否可点
        codeCanLogin() {
            const {phone, code} = this
            return {phone, code}
        }
    },
    watch: {
        // 密码登录时登录按钮是否可点
        //会在任何被侦听的对象的属性值改变时被调用，不论其被嵌套多深
        pwdCanLogin: {
            handler(newval, oldval) {
                console.log(newval, oldval)
                if (newval.tel && this.pwd && this.isAgree) {
                    this.canLogin = true
                } else {
                    this.canLogin = false
                }
            },
            deep: true
        },
        // 验证码登录时登录按钮是否可点
        codeCanLogin: {
            handler(newval, oldval) {
                console.log(newval, oldval)
                if (newval.phone.length === 11 && this.code && this.isAgree) {
                    this.canLogin = true
                } else {
                    this.canLogin = false
                }
            }
        }
    },
    mounted() {
        this.getSysInfo()
        console.log('登录页的mounted');
        window.addEventListener('message', function (event) {
            console.log('收到', event);
            if (event.data.command == 'parentUrl') {
                console.log('收到父页面url', event);
                this.$cookies.set('login_origin', event.data.url, '1d', '', 'zhibo.tv');
            }
        });
    },
    methods: {
        changeVerifyImg() {
            const regExp = new RegExp("^1[3456789]\\d{9}$");
            if (!regExp.test(this.phone)) return Toast('请输入正确的手机号')
            if (this.cutdownIsShow) return Toast(`${this.time}s后可切换`)

            this.cutdownIsShow = true
            this.time = 6
            this.timer()
            this.getSysInfo()
        },
        async getReqId(res, t) {
            const {source, statistics} = this;
            let params = `source=${source}&statistics=${statistics}`
            if (res != 'success') {
                params += `&time=${t}`
            }
            const {data} = await this.$api.getReqId(params)
            const {reqId, code, time, ip} = data.data;

            this.verifyImg = ADDRESS.address2 + '/user/verify?reqId=' + reqId + '&statistics=' + this.statistics//图形验证码

            this.reqId_Len_A = code? Number(code.charAt(0)) - 5:'';//A段长度
            this.reqId = reqId;
            this.reqCode = code;
            this.reqTime = time;
            this.ip = ip;
        },
        encryptionAES(data) {
            const key = CryptoJS.enc.Utf8.parse('JHkZ7thw7829@0*1');
            const iv = CryptoJS.enc.Utf8.parse('Seca888@zhibo.tv');
            const ciphertext = CryptoJS.AES.encrypt(data, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return ciphertext.toString();
        },
        getSysInfo() {
            getIPs((ip, res) => {
                const VS = getBrowserNameVersion();
                const platform = 'pc';//平台  pc ios android
                const channel = VS.split(' ')[0];//渠道 360 小米 chrome
                let version = '2.2';//接口版本号
                let deviceId = ipToNumber(ip);//设备号 ip
                let time = ''
                if (res != 'success') {
                    deviceId = Number(ipToNumber(ip)) + Number(this.source) + Number(parseInt(new Date().getTime() / 1000))
                    time = parseInt(new Date().getTime() / 1000)
                }
                const model = VS.split(' ')[1] ? VS.split(' ')[1] : '1';//浏览器版本
                const useragent = encodeURI(navigator.userAgent);
                const imei = useragent;//base64位 系统信息
                let str = platform + '|' + channel + '|' + version + '|' + this.encryptionAES(deviceId.toString()) + '|' + this.encryptionAES(model) + '|' + this.encryptionAES(imei) + '|' + this.encryptionAES('local') + '|' + '5.7.5' + '|' + 'jhkz7thw7829@0*1'
                str = md5(str)
                str = str.substring(str.length - 8)
                version += `-${str}`;
                this.statistics = platform + '|' + channel + '|' + version + '|' + encodeURIComponent(this.encryptionAES(deviceId.toString())) + '|' + encodeURIComponent(this.encryptionAES(model)) + '|' + encodeURIComponent(this.encryptionAES(imei)) + '|' + encodeURIComponent(this.encryptionAES('local')) + '|' + '5.7.5'

                this.getReqId(res, time)
            })
        },
        // 监听校验手机号
        checkPhone() {
            const regExp = new RegExp("^1[3456789]\\d{9}$");
            if (regExp.test(this.phone) || regExp.test(this.tel)) {
                this.phoneError = false
            } else if (this.tabIndex == 1) {
                this.phoneErrorInfo = '手机号格式错误'
                this.phoneError = true
            }
        },
        // 监听input事件
        handleInput() {
            const regExp = new RegExp("^1[3456789]\\d{9}$");
            if (regExp.test(this.phone) || regExp.test(this.tel)) {
                this.phoneError = false
            }
        },
        // 判断是否是数字
        isNumber(value) {
            var patrn = /^(-)?\d+(\.\d+)?$/
            if (patrn.exec(value) == null || value == '') {
                return false
            } else {
                return true
            }
        },
        // 监听校验验证码
        checkCode() {
            console.log('监听验证码')
        },
        // 关闭弹窗
        handleClose() {
            console.log(window)
            // parent.location.reload()
            // 处理iframe跨域
            window.parent.postMessage({command: 'reload'}, '*')
        },
        // 切换tab高亮
        changeTabIndex(index) {
            if (this.tabIndex == index) return
            this.tabIndex = index
            this.canLogin = false
            this.phoneError = false
            this.tel = ''
            this.pwd = ''
            this.phone = ''
            this.code = ''
            this.imgCode = ''
        },
        // 记住7天或取消记住7天
        changeRemember() {
            this.isRemember = !this.isRemember
        },
        // 同意协议或取消同意
        changeAgree() {
            this.isAgree = !this.isAgree
            if (
                this.phone.length === 11 &&
                this.code &&
                this.isAgree &&
                this.tabIndex == 1
            ) {
                this.canLogin = true
            } else if (
                this.tel &&
                this.pwd &&
                this.isAgree &&
                this.tabIndex == 0
            ) {
                this.canLogin = true
            } else {
                this.canLogin = false
            }
        },
        // 忘记密码
        forgetPwd() {
            window.open(`https://${process.env.VUE_APP_BASE}v.zhibo.tv/user/change-password`)
        },
        // 协议跳转
        gotoAgree(index) {
            if (index == 1) {
                window.open('https://www.zhibo.tv/news/3864')
            }
            if (index == 2) {
                window.open('https://static.zhibo.tv/agreement/privacy_agreement.html')
            }
        },
        // 点击登录按钮
        async gotoLogin() {
            if (this.tabIndex === 0) {
                if (!this.tel) {
                    // Toast('请输入手机号')
                } else {
                    // 手机号+密码登录
                    this.loginByPwd()
                }
            }
            if (this.tabIndex === 1) {
                // 手机号+验证码登录
                this.loginByTel()
            }
        },
        setReqId() {
            const reqId_first_code = (this.reqId.charAt(0)).charCodeAt()
            const phone_last_nine = Number(this.phone.substring(2)) + Number(reqId_first_code);//手机号后九位 + reqId第一位的ascii码
            const remainder_number = phone_last_nine % 26;//除以26取余 0-25
            const remainder_letter = String.fromCharCode(Number(remainder_number) + Number(97));//手机号后9位+reqId第一位的ascii码,%26取余,对应a-z
            const remainder_index = phone_last_nine % 4;//手机号后9位+reqId第一位的ascii码,%4取余
            let str = generateLetters(4)//生成一个随机字母字符
            str = replaceCharAtIndex(str, remainder_index, 1, remainder_letter)//替换 字符,开始索引,长度,值
            // console.log('重排后得reqId==========>',replaceCharAtIndex(this.reqId,this.reqId_Len_A,4,str))
            return replaceCharAtIndex(this.reqId, this.reqId_Len_A, 4, str)
        },
        sortArray() {
            const {setReqId, phone, imgCode, reqTime, source, ip, statistics} = this;
            let newReqId = setReqId();
            let reqId = md5(newReqId + '$^>*<@' + 'JHKZ7THW7829@0*1');
            reqId = reqId.substring(reqId.length - 6)
            reqId = newReqId + reqId
            //key值按照a-z的顺序拼接
            const params = {code: imgCode, ip: ip, phone: phone, reqId: reqId, source: source, time: reqTime}
            let str = '';
            Object.values(params).forEach(e => {
                str += `${e}&`
            })
            str = str + 'jhkz7thw7829@0*1'
            str = md5(str)
            str = str.substring(str.length - 8)
            params.sign = str
            params.statistics = statistics
            params.phone = this.encryptionAES(phone)
            return params
        },
        // 获取验证码
        async getCode() {
            if (this.cutdownIsShow) return
            const regExp = new RegExp("^1[3456789]\\d{9}$");
            if (regExp.test(this.phone)) {
                if (this.imgCode.length === 4) {
                    const params = this.sortArray()
                    const res = await this.$api.sendCodefromPC(Qs.stringify(params))
                    if (res.data.control.status == 200) {
                        this.time = 60
                    } else {
                        this.imgCode = ''
                        this.time = 6
                        this.getSysInfo()
                    }
                    this.cutdownIsShow = true
                    Toast(res.data.control.message)
                    this.timer()
                } else {
                    Toast('请输入正确的图形验证码')
                }
            } else {
                Toast('请输入正确的手机号')
            }
        },
        // 验证码的倒计时
        timer() {
            if (this.time > 1) {
                this.time--
                this.sendtxt = this.time + 's后获取'
                setTimeout(this.timer, 1000)
            } else {
                this.time = 0
                this.cutdownIsShow = false
            }
        },
        // 手机号+密码登录
        async loginByPwd() {
            let params = Qs.stringify({
                phone: this.encryptionAES(this.tel),
                password: this.encryptionAES(this.pwd),
                isRemeber: Number(this.isRemember),
                statistics: this.statistics,
                verify: this.verify
            })
            let res = await this.$api.getLoginBypwd(params)
            console.log(res)
            this.addition = res.data.addition
            if (this.addition > 3) {
                this.getGraphImg()
            }
            if (res.data.status == 200) {
                Toast('登录成功')
                setTimeout(() => {
                    // parent.location.reload()
                    // 处理iframe跨域
                    window.parent.postMessage({command: 'reload'}, '*')
                }, 500)
            } else {
                Toast(res.data.data)
            }
        },
        // 手机号+验证码登录
        async loginByTel() {
            let params = Qs.stringify({
                phone: this.encryptionAES(this.phone),
                code: this.code,
                statistics: this.statistics,
            })
            let res = await this.$api.codeLoginfromPC(params)
            console.log(res)
            if (res.data.status == 200) {
                Toast('登录成功')
                setTimeout(() => {
                    // parent.location.reload()
                    // 处理iframe跨域
                    window.parent.postMessage({command: 'reload'}, '*')
                }, 500)
            } else {
                Toast(res.data.data)
            }
        },
        // 获取图形验证码
        getGraphImg() {
            var num = Math.random().toFixed(9) * 1000000000 // 生成一个随机数（防止缓存）
            this.graphImg = `https://${process.env.VUE_APP_BASE}v.zhibo.tv/ajax/ajax/verify?version=${num}`
        },
        // 处理第三方登录
        handleThirdLogin(type) {
            this.$cookies.set('login_terminal', 'PC', '1d', '', 'zhibo.tv')
            this.$cookies.set('login_type', type, '1d', '', 'zhibo.tv')
            // 不在这个页面处理三方了,发消息通知父页面去处理
            console.log('发消息通知父页面去处理三方')
            window.parent.postMessage({command: 'thirdLogin', type}, '*')
        }
    }
}
</script>

<style lang="less" scoped>
.pcLogin {
    font-size: 12px;

    .mask {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);

        .pcloginDialog {
            width: 460px;
            // height: 477px;
            background: #ffffff;
            box-shadow: 2px 11px 13px 0px rgba(88, 88, 88, 0.19);
            border-radius: 4px;
            box-sizing: border-box;
            padding: 0 50px;
            position: relative;

            .icon_close {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                background: url('https://images.zhibo.tv/2022/0221/icon_close.png') no-repeat center;
                background-size: 50%;
                position: absolute;
                top: 10px;
                right: 10px;
                cursor: pointer;

                &:hover {
                    background: url('https://images.zhibo.tv/2022/0221/icon_close_w.png') #999999 no-repeat center;
                    background-size: 50%;
                }
            }

            .mainBox {
                .tabBox {
                    padding: 30px 50px;
                    display: flex;
                    justify-content: space-between;

                    .tabItem {
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 27px;
                        cursor: pointer;
                    }

                    .activeItem {
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #e9001d;
                    }
                }

                .infoBox {
                    .inputBox {
                        width: 360px;
                        height: 50px;
                        border-bottom: 1px solid #e5e5e5;
                        position: relative;

                        input {
                            outline: none;
                            width: 100%;
                            height: 50px;
                            font-size: 20px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        input::placeholder {
                            font-size: 16px;
                            font-family: PingFangSC-Light, PingFang SC;
                            font-weight: 300;
                            color: #999999;
                            // line-height: 27px;
                        }

                        .error {
                            position: absolute;
                            right: 0;
                            top: 17px;
                            display: flex;
                            align-items: center;
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #d0021b;

                            i {
                                width: 16px;
                                height: 16px;
                                margin-left: 10px;
                                display: block;
                                background: url('https://images.zhibo.tv/3x/icon_mistake@3x.png') no-repeat center;
                                background-size: 100%;
                            }
                        }

                        .warning {
                        }
                    }

                    .tel {
                        margin-bottom: 20px;

                    }

                    .imgCode {
                        margin-bottom: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        input {
                            width: 200px;

                            &::-webkit-inner-spin-button {
                                -webkit-appearance: none !important;
                            }
                        }

                        img {
                            width: 120px;
                            height: 40px;
                            cursor: pointer;
                            pointer-events: unset;
                        }
                    }

                    .graph {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-top: 20px;

                        .graphInput {
                            width: 200px;
                        }

                        .graphImg {
                            width: 115px;
                            height: 42px;

                            img {
                                width: 115px;
                                height: 42px;
                            }
                        }
                    }

                    .handle {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 50px;

                        .rememberBox {
                            font-size: 14px;
                            font-family: PingFangSC-Light, PingFang SC;
                            font-weight: 300;
                            color: #333333;
                            cursor: pointer;
                            display: flex;
                            align-items: center;

                            i {
                                display: block;
                                width: 14px;
                                height: 14px;
                                margin-right: 6px;
                                background: url('https://images.zhibo.tv/pc/icon_fff.png') no-repeat center;
                                background-size: 100%;
                            }

                            .icon_checked {
                                background: url('https://images.zhibo.tv/3x/icon_checked@3x.png') no-repeat center;
                                background-size: 100%;
                            }
                        }

                        .forget {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #999999;
                            cursor: pointer;

                            &:hover {
                                color: #e9001d;
                            }
                        }
                    }
                }

                .infoBox1 {
                }

                .infoBox2 {
                    // margin-bottom: 20px;
                    .pwd {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        input {
                            width: 200px;
                        }
                    }

                    .sendCode {
                        cursor: pointer;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;

                        &:hover {
                            font-weight: 500;
                            color: #e9001d;
                        }
                    }

                    .second {
                        font-weight: 500;
                        color: #999999;
                    }

                    .handle {
                        justify-content: flex-end;
                    }
                }

                .loginBtn {
                    width: 360px;
                    height: 50px;
                    margin-bottom: 10px;
                    margin-top: 10px;
                    background: #ccc;
                    border-radius: 25px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #ffffff;
                }

                .canLogin {
                    background: #e9001d;
                    cursor: pointer;

                    &:hover {
                        opacity: 0.9;
                    }
                }

                .agreement {
                    height: 50px;
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    font-family: PingFangSC-Light, PingFang SC;
                    font-weight: 300;
                    color: #999999;

                    i {
                        display: block;
                        width: 14px;
                        height: 14px;
                        margin-right: 6px;
                        background: url('https://images.zhibo.tv/pc/icon_fff.png') no-repeat center;
                        background-size: 100%;
                        cursor: pointer;
                    }

                    .icon_checked {
                        background: url('https://images.zhibo.tv/3x/icon_checked@3x.png') no-repeat center;
                        background-size: 100%;
                    }

                    span {
                        cursor: pointer;
                        color: #333333;
                        cursor: pointer;

                        &:hover {
                            color: #e9001d;
                        }
                    }
                }

                .thirdLogin {
                    margin-top: 20px;
                    margin-bottom: 30px;

                    .thirdList {
                        display: flex;
                        justify-content: space-between;

                        .thirdItem {
                            width: 50px;
                            height: 50px;
                            cursor: pointer;
                        }

                        .thirdqq {
                            background: url('https://images.zhibo.tv/3x/icon_qq@3x.png') no-repeat center;
                            background-size: 100%;

                            a {
                                display: block;
                                width: 50px;
                                height: 50px;

                                img {
                                    display: none;
                                }
                            }

                            &:hover {
                                background: url('https://images.zhibo.tv/3x/icon_qq_h@3x.png') no-repeat center;
                                background-size: 100%;
                            }
                        }

                        .thirdwx {
                            background: url('https://images.zhibo.tv/3x/icon_weixin@3x.png') no-repeat center;
                            background-size: 100%;

                            &:hover {
                                background: url('https://images.zhibo.tv/3x/icon_weixin_h@3x.png') no-repeat center;
                                background-size: 100%;
                            }
                        }

                        .thirdsina {
                            background: url('https://images.zhibo.tv/3x/icon_weibo@3x.png') no-repeat center;
                            background-size: 100%;

                            &:hover {
                                background: url('https://images.zhibo.tv/3x/icon_weibo_h@3x.png') no-repeat center;
                                background-size: 100%;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
